import { c as _c } from "react/compiler-runtime";
import { DescriptionSkeleton } from './description-skeleton';
import { ExpandableInfoSkeleton } from './expandable-info-skeleton';
function ProductInfoSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DescriptionSkeleton />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex w-full flex-col gap-6">{t0}<div className="flex w-full flex-col gap-4"><ExpandableInfoSkeleton isFirst={true} /><ExpandableInfoSkeleton /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export { ProductInfoSkeleton };